import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { ProductMetaInfo, Key } from './productMetaInfo'
import { IDetailPageState } from '../../reducers'
import {
  sanitizedRequestContextSelector,
  IRequestContext
} from '../../selectors/requestContext'
import { pageSelectors } from '../../selectors/basicState'
import * as st from '../utilityClasses.module.scss'
import { Container } from '@amzn/dvui/dist/Container'
import { isTV } from '../../utils/entityTypes'

const VISIBLE_ITEMS_BTF = 5

const retailBtfKeys = (isTV: boolean) => [
  ...(isTV ? [Key.Directors] : []),
  Key.Actors,
  Key.Producers,
  Key.ReleaseYear,
  Key.Studios,
  Key.RegRating,
  Key.ContentDescriptors,
  Key.PurchaseRights,
  Key.Format,
  Key.Devices
]

const pvBtfKeys = (isTV: boolean) => [
  ...(isTV ? [Key.Directors] : []),
  Key.Producers,
  Key.Studios,
  Key.Amr,
  Key.ContentDescriptors,
  Key.Actors
]

export interface Props {
  productDetails?: WpsRuntime.atv.wps.DetailFragmentModelProps
  requestContext: IRequestContext
}

export const ConnectedBtfProductMetaInfo = ({
  productDetails,
  requestContext
}: Props) => {
  if (!productDetails) {
    return null
  } else {

    const isTv = isTV(productDetails)

    return (
      <Container className={st.pageSection}>
        <ProductMetaInfo
          {...productDetails}
          fields={requestContext.isRetail ? retailBtfKeys(isTv) : pvBtfKeys(isTv)}
          showHeader
          expandedItemsCount={VISIBLE_ITEMS_BTF}
          id="btf-product-details"
        />
      </Container>
    )
  }
}

const mapStateToProps = (state: IDetailPageState): Props => ({
  productDetails: pageSelectors.detail(state),
  requestContext: sanitizedRequestContextSelector(state)
})

export const BtfProductMetaInfo = connect(mapStateToProps)(
  ConnectedBtfProductMetaInfo
)
